<template>
    <!--
      	作者：gmshop
      	时间：2020-06-20
      	描述：diy组件-模拟显示-导航组
      -->
    <div>
      <div class="drag optional">
        <div class="diy-navBar">
          <ul class="list" :class="'column-'+item.style.rowsNum">
            <li class="item" :key="index" v-for="(navBar,index) in item.data">
              <div class="item-image">
                <img v-img-url="navBar.imgUrl">
              </div>
              <div class="item-text text-ellipsis" :style="{color:navBar.color}">
                {{navBar.text}}</div>
                <i v-if="item.style.rowsNum==1" class="icon iconfont2 icon-right el-icon-arrow-right"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['item'],
    methods: {

    }
  };
</script>

<style>
.diy-navBar .list{ display: flex; flex-wrap: wrap; align-items: flex-start;}
.diy-navBar .list .item{ padding: 10px 0; display: flex; justify-content: center; align-items: center; flex-direction: column;}
.diy-navBar .list.column-1 .item{
  width: 100%;
  border-bottom: #cccccc 1px solid;
  display: inline;
  margin-left: 12px;
  
}
.diy-navBar .list.column-1 .item .item-text {
    display: inline;
    height: 30px;
  }
 .diy-navBar .list.column-1 .item .item-image {
    display: inline;
    width: 30px;
    height: 30px;
    vertical-align: middle;
  
  }
  .diy-navBar .list.column-1 .item  img {
      display: inline;
      width: 30px;
      border-radius: 50%;
    }
  .diy-navBar .list.column-1 .item .icon.iconfont2.icon-right {
    line-height: 30px;
    margin-right: 5px;
    float: right;
  }
.diy-navBar .list.column-2 .item{ width: 50%;}
.diy-navBar .list.column-3 .item{ width: 33.333333333%;}
.diy-navBar .list.column-4 .item{ width: 25%;}
.diy-navBar .list.column-5 .item{ width: 20%;}
.diy-navBar .list .item-image{ width: 60%;}
.diy-navBar .list .item-image img{ width: 100%;}
.diy-navBar .list .item-text{ width: 100%; padding: 4px 0; text-align: center;}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/NavBarUser.vue